import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbModelsEvents } from '@irb-common/events';
import { ImportSecurityModelsContainsGridLayoutService } from '@irb/irb-models/import-security-model-contains-dialog/import-security-model-contains.grid-layout.service';
import { ModelsService } from '@irb/irb-models//models-new/models.service';

@Component({ standalone: false,
  selector: 'irb-import-security-model-contains-dialog',
  templateUrl: './import-security-model-contains-dialog.component.html',
  styleUrls: ['./import-security-model-contains-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportSecurityModelsContainsDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<ImportSecurityModelsContainsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportSecurityModelsContainsGridLayoutService,
    public modelsService: ModelsService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    //this.grid.api.sizeColumnsToFit();
  }

  completeContains() {   
    
    this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_RESULT, this.data);

    this.close();

  }
}
